import React, { useState } from 'react';
import SEO from '../components/SEO';
import seoData from '../config/seoData';
import { Phone, MessageCircle, ChevronDown, ChevronUp, Search, Instagram } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const FAQLocacaoLavadoraPiso = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const whatsappNumber = "5531971823249";
  const whatsappMessage = encodeURIComponent("Olá! Tenho uma dúvida sobre locação de lavadora de piso que não encontrei no FAQ.");

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`, '_blank');
  };

  const handleCallClick = () => {
    window.location.href = 'tel:+5531971823249';
  };

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqCategories = [
    {
      category: "Valores e Condições Comerciais",
      questions: [
        {
          question: "Quanto custa alugar uma lavadora de piso em Belo Horizonte?",
          answer: "O custo de locação varia conforme o modelo do equipamento, período de contrato e serviços inclusos. Em média, a locação mensal pode variar de R$ 800 a R$ 3.500. Lavadoras pedestres (walk-behind) custam entre R$ 800 e R$ 1.500/mês. Lavadoras tripuladas a bateria ficam entre R$ 2.000 e R$ 2.800/mês. Lavadoras tripuladas a GLP custam entre R$ 2.500 e R$ 3.500/mês. Varredeiras industriais variam de R$ 1.200 a R$ 2.500/mês. Todos os valores incluem manutenção preventiva e corretiva, peças de reposição, treinamento e suporte técnico. Contratos de longo prazo (12-24 meses) têm condições especiais. Solicite orçamento personalizado via WhatsApp."
        },
        {
          question: "Qual o prazo mínimo de locação?",
          answer: "A WellTec oferece contratos flexíveis a partir de 30 dias. Também atendemos locações pontuais para eventos, limpezas pós-obra, reformas ou necessidades sazonais. Para projetos de longo prazo (6, 12 ou 24 meses), oferecemos descontos progressivos e condições especiais. A renovação é automática e não há multa de cancelamento com aviso prévio de 30 dias."
        },
        {
          question: "O que está incluído no valor da locação?",
          answer: "O valor mensal da locação na WellTec inclui: manutenção preventiva programada (revisões periódicas), manutenção corretiva (reparos quando necessário), peças de reposição originais, treinamento operacional completo da equipe, equipamento reserva em caso de necessidade, suporte técnico via WhatsApp/telefone, atendimento presencial em até 24 horas e consultoria técnica contínua. Não há custos ocultos ou taxas extras. O único custo adicional são os produtos químicos de limpeza (detergentes) e a energia elétrica/GLP para abastecimento."
        },
        {
          question: "Há taxa de entrega e instalação?",
          answer: "Para contratos de locação acima de 6 meses, a entrega, instalação e treinamento são totalmente gratuitos na região metropolitana de Belo Horizonte (BH, Contagem, Betim, Nova Lima, Mário Campos). Para contratos de curto prazo (1-3 meses), locações pontuais ou outras cidades de Minas Gerais, pode haver cobrança de frete dependendo da distância e duração do contrato. Consulte condições específicas para sua região via WhatsApp (31) 97182-3249."
        },
        {
          question: "Vocês oferecem desconto para contratos longos?",
          answer: "Sim! Para contratos de 12 meses, oferecemos até 10% de desconto no valor mensal. Para contratos de 24 meses ou mais, o desconto pode chegar a 15%. Além disso, clientes que locam mais de um equipamento simultaneamente têm condições especiais. Entre em contato para negociar um plano personalizado para sua empresa."
        }
      ]
    },
    {
      category: "Manutenção e Suporte Técnico",
      questions: [
        {
          question: "A manutenção está incluída no aluguel?",
          answer: "Sim! Todos os planos de locação da WellTec incluem manutenção preventiva (revisões programadas, limpeza de filtros, lubrificação, ajustes) e manutenção corretiva (reparos de falhas, substituição de peças danificadas). Nossa equipe técnica realiza visitas periódicas para garantir o funcionamento ideal do equipamento. Você paga um valor fixo mensal e não precisa se preocupar com custos adicionais de manutenção ou peças."
        },
        {
          question: "Qual o prazo de atendimento em caso de problema?",
          answer: "A WellTec garante atendimento técnico presencial em até 24 horas úteis para a região metropolitana de Belo Horizonte (BH, Contagem, Betim, Nova Lima, Mário Campos). Em casos de urgência, priorizamos o atendimento em até 12 horas. Para outras localidades de Minas Gerais, o prazo pode variar de acordo com a distância. Enquanto o equipamento está em manutenção, disponibilizamos uma máquina reserva (backup) para não parar suas operações. Nosso suporte via WhatsApp e telefone funciona de segunda a sexta, das 08h às 18h."
        },
        {
          question: "Vocês fornecem equipamento reserva durante a manutenção?",
          answer: "Sim! Em caso de manutenção corretiva que exija mais de 4 horas ou retirada do equipamento, a WellTec disponibiliza uma máquina reserva (backup) equivalente sem custo adicional. Isso garante que suas operações de limpeza não sejam interrompidas. O equipamento reserva é entregue e instalado no mesmo dia ou, no máximo, em até 24 horas."
        },
        {
          question: "Posso solicitar treinamento adicional para novos funcionários?",
          answer: "Sim! O treinamento operacional é incluído no contrato de locação. Se sua empresa contratar novos funcionários durante o período de locação, basta nos avisar e agendaremos um novo treinamento sem custo adicional. O treinamento cobre: operação básica e avançada do equipamento, segurança do operador, técnicas de limpeza eficiente, manutenção básica (limpeza de filtros, reabastecimento), e solução de problemas comuns."
        }
      ]
    },
    {
      category: "Tipos de Equipamentos e Escolha",
      questions: [
        {
          question: "Qual a diferença entre lavadora pedestre e tripulada?",
          answer: "Lavadoras pedestres (walk-behind) são operadas a pé, ideais para áreas de 300 a 2.000 m², como supermercados, hospitais, escolas e lojas. São mais compactas, fáceis de manobrar e consomem menos energia. Lavadoras tripuladas (ride-on) possuem assento para o operador, são mais produtivas e indicadas para áreas acima de 2.000 m², como indústrias, centros de distribuição, aeroportos e grandes galpões. Podem ser a bateria (zero emissões, silenciosas, para ambientes fechados) ou a GLP (máxima autonomia, para áreas externas e operações contínuas). A escolha depende do tamanho da área, tipo de piso, frequência de limpeza e ambiente (interno/externo)."
        },
        {
          question: "Qual equipamento é ideal para minha empresa?",
          answer: "A escolha do equipamento ideal depende de vários fatores: tamanho da área (metros quadrados), tipo de piso (cerâmica, porcelanato, industrial, resina), nível de sujidade (leve, média, pesada), frequência de limpeza (diária, semanal), ambiente (interno, externo, com ventilação), e restrições operacionais (horário, ruído, emissões). A WellTec oferece análise técnica gratuita no local para avaliar essas variáveis e recomendar o modelo mais adequado. Nossa equipe visita sua empresa, analisa as necessidades e propõe a solução mais eficiente e econômica."
        },
        {
          question: "Vocês têm lavadoras para limpeza externa (estacionamentos, pátios)?",
          answer: "Sim! Para áreas externas, recomendamos lavadoras tripuladas a GLP, que oferecem máxima autonomia e não dependem de recarga elétrica. São ideais para estacionamentos, pátios industriais, áreas de carga/descarga e grandes áreas abertas. Também possuem tração 4x4 para terrenos irregulares e tanques de água de alta capacidade (até 250 litros). Para limpeza a seco (remoção de folhas, detritos, areia), oferecemos varredeiras industriais com alta capacidade de sucção."
        },
        {
          question: "Qual a produtividade de uma lavadora de piso?",
          answer: "A produtividade varia conforme o modelo: Lavadoras pedestres limpam entre 1.500 e 2.500 m²/hora. Lavadoras tripuladas a bateria limpam entre 3.000 e 5.000 m²/hora. Lavadoras tripuladas a GLP limpam entre 4.000 e 6.000 m²/hora. Varredeiras industriais varrem entre 5.000 e 8.000 m²/hora. Esses valores consideram operação em condições normais. A produtividade real pode variar conforme nível de sujidade, tipo de piso, obstáculos e experiência do operador."
        }
      ]
    },
    {
      category: "Área de Atendimento e Logística",
      questions: [
        {
          question: "Vocês atendem toda região de Belo Horizonte?",
          answer: "Sim! A WellTec atende todo o estado de Minas Gerais. Temos atendimento completo na região metropolitana de Belo Horizonte, incluindo: Belo Horizonte (todos os bairros), Contagem, Betim, Nova Lima, Mário Campos, Ibirité, Ribeirão das Neves, Santa Luzia, Sabará, Vespasiano e Pedro Leopoldo. Também atendemos outras cidades e regiões de Minas Gerais com entrega, instalação e suporte técnico. Entre em contato para consultar disponibilidade e prazos para sua localidade."
        },
        {
          question: "Quanto tempo demora a entrega após a contratação?",
          answer: "Após a aprovação do orçamento e assinatura do contrato, a entrega e instalação são realizadas em até 48 horas úteis para a região metropolitana de Belo Horizonte. Para outras cidades de Minas Gerais, o prazo pode variar de 3 a 7 dias úteis dependendo da localidade. Em casos de urgência (limpezas pós-obra, eventos), podemos agilizar a entrega para o mesmo dia ou próximo dia útil na região de BH, sujeito à disponibilidade de equipamentos. O treinamento operacional é realizado imediatamente após a instalação."
        },
        {
          question: "Vocês fazem a retirada do equipamento ao final do contrato?",
          answer: "Sim! Ao final do contrato de locação, a WellTec realiza a retirada do equipamento sem custo adicional. Basta nos avisar com 7 dias de antecedência para agendarmos a retirada em um horário conveniente para sua empresa. Caso deseje renovar o contrato, a renovação é automática e não há necessidade de retirada."
        }
      ]
    },
    {
      category: "Operação e Segurança",
      questions: [
        {
          question: "É necessário algum treinamento especial para operar?",
          answer: "Não é necessário certificação prévia, mas é obrigatório o treinamento operacional fornecido pela WellTec. O treinamento tem duração de 1 a 2 horas e é realizado por técnicos especializados. Ensinamos: operação básica e avançada do equipamento, segurança do operador e de terceiros, técnicas de limpeza eficiente, manutenção básica (limpeza de filtros, reabastecimento), e solução de problemas comuns. Ao final, o operador recebe um certificado de conclusão. O treinamento está incluído no contrato de locação."
        },
        {
          question: "As lavadoras consomem muita água?",
          answer: "Não! As lavadoras de piso industriais são projetadas para alta eficiência no consumo de água. Lavadoras pedestres consomem entre 20 e 40 litros/hora. Lavadoras tripuladas consomem entre 50 e 100 litros/hora. Comparado à limpeza manual (que pode consumir até 300 litros/hora), a economia de água é de até 70%. Além disso, as lavadoras possuem sistema de recuperação de água, permitindo reutilização parcial. Isso reduz custos operacionais e impacto ambiental."
        },
        {
          question: "Qual o consumo de energia elétrica (lavadoras a bateria)?",
          answer: "Lavadoras tripuladas a bateria consomem entre 3 e 8 kWh por recarga completa, dependendo do modelo e capacidade da bateria. Uma recarga custa aproximadamente R$ 2 a R$ 6 (considerando tarifa média de R$ 0,75/kWh). A autonomia varia de 2 a 4 horas de operação contínua, o suficiente para limpar até 8.000 m² por recarga. Lavadoras pedestres a bateria possuem consumo menor, entre 1 e 3 kWh por recarga."
        },
        {
          question: "É seguro operar em ambientes com pessoas circulando?",
          answer: "Sim! As lavadoras profissionais possuem recursos de segurança como freio automático ao soltar a alavanca de comando, alarme sonoro de ré (em modelos tripulados), baixo centro de gravidade para estabilidade, e visibilidade 360° para o operador. No entanto, é recomendável realizar a limpeza em horários de menor movimento ou sinalizar a área durante a operação. O treinamento da WellTec inclui orientações sobre segurança operacional e prevenção de acidentes."
        }
      ]
    },
    {
      category: "Comparação: Locação vs Compra",
      questions: [
        {
          question: "Vale mais a pena alugar ou comprar uma lavadora de piso?",
          answer: "A locação é mais vantajosa na maioria dos casos. Veja a comparação: COMPRA: Investimento inicial alto (R$ 15.000 a R$ 80.000), manutenção e peças por conta do cliente (custo anual de 15-20% do valor do equipamento), depreciação do ativo em 5-7 anos, risco de obsolescência tecnológica, necessidade de espaço para armazenamento. LOCAÇÃO: Sem investimento inicial, manutenção e peças incluídas no contrato, equipamento sempre atualizado, equipamento reserva em caso de falha, flexibilidade para trocar ou devolver, despesa dedutível de IR. A locação só não é vantajosa para empresas com uso muito intenso (24h/dia) ou que planejam usar o equipamento por mais de 7 anos."
        },
        {
          question: "Posso comprar o equipamento ao final do contrato?",
          answer: "Sim! Ao final do contrato de locação, você tem a opção de comprar o equipamento por um valor residual negociado. Dependendo do tempo de locação, o valor residual pode variar de 30% a 60% do preço de um equipamento novo. Entre em contato para negociar as condições de compra."
        }
      ]
    }
  ];

  // Flatten all questions for search
  const allQuestions = faqCategories.flatMap(cat => 
    cat.questions.map(q => ({ ...q, category: cat.category }))
  );

  // Filter questions based on search
  const filteredCategories = searchTerm.trim() === '' 
    ? faqCategories 
    : faqCategories.map(cat => ({
        ...cat,
        questions: cat.questions.filter(q => 
          q.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
          q.answer.toLowerCase().includes(searchTerm.toLowerCase())
        )
      })).filter(cat => cat.questions.length > 0);

  return (
    <div className="min-h-screen
      <SEO 
        title={seoData['/faq-locacao-lavadora-piso'].title}
        description={seoData['/faq-locacao-lavadora-piso'].description}
        canonical={seoData['/faq-locacao-lavadora-piso'].canonical}
      /> bg-white">
      <Helmet>
        <title>FAQ Locação de Lavadora de Piso BH | Perguntas Frequentes | WellTec</title>
        <meta name="description" content="Perguntas frequentes sobre locação de lavadora de piso em BH. Tire suas dúvidas sobre valores, manutenção, tipos de equipamentos, área de atendimento e muito mais. ☎ (31) 97182-3249" />
        <meta name="keywords" content="faq locação lavadora piso, dúvidas aluguel lavadora, perguntas frequentes limpeza industrial, quanto custa alugar lavadora, manutenção inclusa, lavadora pedestre ou tripulada" />
        <link rel="canonical" href="https://www.wellttec.com/faq-locacao-lavadora-piso" />
        
        {/* Open Graph */}
        <meta property="og:title" content="FAQ Locação de Lavadora de Piso BH | Tire Suas Dúvidas" />
        <meta property="og:description" content="Encontre respostas para as principais dúvidas sobre locação de lavadoras industriais: valores, manutenção, tipos de equipamentos e área de atendimento." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.wellttec.com/faq-locacao-lavadora-piso" />
      </Helmet>

      {/* FAQPage Schema */}
      

      {/* Breadcrumb Schema */}
      

      {/* Fixed WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50 animate-bounce-slow">
        <Button
          onClick={handleWhatsAppClick}
          className="bg-green-500 hover:bg-green-600 text-white rounded-full w-16 h-16 shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110"
        >
          <MessageCircle className="w-8 h-8" />
        </Button>
      </div>

      {/* Header */}
      <header className="bg-slate-900 text-white py-4 px-6 sticky top-0 z-40 shadow-lg">
        <div className="container mx-auto flex justify-between items-center">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigate('/')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/9nveujmi_file_00000000e2f071f5a40c0fc04e1c9bed.png" 
              alt="WellTec Logo" 
              className="h-16 w-auto"
            />
          </div>
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="hover:text-blue-400 transition-colors">Início</Link>
            <Link to="/servicos" className="hover:text-blue-400 transition-colors">Serviços</Link>
            <Link to="/limpeza-pos-obra" className="hover:text-green-400 transition-colors">Limpeza Pós-Obra</Link>
            <Link to="/locacao-lavadora-piso" className="hover:text-blue-400 transition-colors">Locação</Link>
            <Link to="/blog" className="hover:text-blue-400 transition-colors">Blog</Link>
            <a 
              href="https://www.instagram.com/welltecbrasil/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-blue-400 transition-colors"
              title="Instagram @welltecbrasil"
            >
              <Instagram className="w-5 h-5" />
            </a>
            <Button onClick={handleWhatsAppClick} className="bg-green-500 hover:bg-green-600">
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp
            </Button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="bg-slate-900 text-white py-20">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            Perguntas Frequentes sobre Locação de Lavadora de Piso
          </h1>
          <p className="text-base md:text-lg text-gray-300 max-w-3xl mx-auto mb-8">
            Encontre respostas rápidas e completas para as principais dúvidas sobre aluguel de lavadoras industriais em Belo Horizonte e região
          </p>
          
          {/* Search Bar */}
          <div className="max-w-2xl mx-auto">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Buscar pergunta... (ex: quanto custa, manutenção, prazo)"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-4 text-slate-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            
            {filteredCategories.length === 0 && (
              <div className="text-center py-12">
                <p className="text-lg text-gray-600 mb-6">
                  Nenhuma pergunta encontrada para &ldquo;{searchTerm}&rdquo;
                </p>
                <Button onClick={() => setSearchTerm('')} variant="outline">
                  Limpar Busca
                </Button>
              </div>
            )}

            {filteredCategories.map((category, catIndex) => (
              <div key={catIndex} className="mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-6 border-b-2 border-blue-600 pb-2">
                  {category.category}
                </h2>
                <div className="space-y-4">
                  {category.questions.map((faq, qIndex) => {
                    const globalIndex = `${catIndex}-${qIndex}`;
                    const isOpen = openIndex === globalIndex;
                    
                    return (
                      <Card key={qIndex} className="border-slate-200 hover:border-blue-500 transition-all duration-300">
                        <CardContent className="p-0">
                          <button
                            onClick={() => toggleFAQ(globalIndex)}
                            className="w-full text-left p-6 flex justify-between items-start hover:bg-gray-50 transition-colors"
                          >
                            <span className="text-lg font-semibold text-slate-900 pr-4">
                              {faq.question}
                            </span>
                            {isOpen ? (
                              <ChevronUp className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                            ) : (
                              <ChevronDown className="w-6 h-6 text-gray-400 flex-shrink-0 mt-1" />
                            )}
                          </button>
                          {isOpen && (
                            <div className="px-6 pb-6">
                              <p className="text-gray-700 leading-relaxed">
                                {faq.answer}
                              </p>
                            </div>
                          )}
                        </CardContent>
                      </Card>
                    );
                  })}
                </div>
              </div>
            ))}

            {/* CTA Card */}
            <Card className="bg-blue-600 text-white border-0 mt-12">
              <CardContent className="p-8 text-center">
                <h3 className="text-2xl md:text-3xl font-bold mb-4">
                  Não encontrou sua dúvida?
                </h3>
                <p className="text-lg mb-6">
                  Nossa equipe está pronta para responder qualquer pergunta adicional
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button
                    onClick={handleWhatsAppClick}
                    size="lg"
                    className="bg-green-500 hover:bg-green-600 text-white"
                  >
                    <MessageCircle className="w-5 h-5 mr-2" />
                    Falar no WhatsApp
                  </Button>
                  <Button
                    onClick={handleCallClick}
                    size="lg"
                    variant="outline"
                    className="bg-white text-blue-600 hover:bg-gray-100"
                  >
                    <Phone className="w-5 h-5 mr-2" />
                    Ligar Agora
                  </Button>
                </div>
              </CardContent>
            </Card>

          </div>
        </div>
      </section>

      {/* Back to Locação Page */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-6 text-center">
          <Button
            onClick={() => navigate('/locacao-lavadora-piso')}
            size="lg"
            variant="outline"
            className="border-blue-600 text-blue-600 hover:bg-blue-50"
          >
            Voltar para Página de Locação
          </Button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="mb-4">
                <img 
                  src="https://customer-assets.emergentagent.com/job_locacao-pisos/artifacts/9nveujmi_file_00000000e2f071f5a40c0fc04e1c9bed.png" 
                  alt="WellTec Logo" 
                  className="h-20 w-auto"
                />
              </div>
              <p className="text-gray-400 mb-4">
                Especialistas em locação e manutenção de lavadoras de piso industriais.
              </p>
              <a 
                href="https://www.instagram.com/welltecbrasil/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 text-gray-400 hover:text-white transition-colors"
              >
                <Instagram className="w-5 h-5" />
                <span>@welltecbrasil</span>
              </a>
            </div>
            <div>
              <h5 className="text-lg font-bold mb-4">Links Rápidos</h5>
              <ul className="space-y-2">
                <li><Link to="/" className="text-gray-400 hover:text-white transition-colors">Início</Link></li>
                <li><Link to="/servicos" className="text-gray-400 hover:text-white transition-colors">Serviços</Link></li>
                <li><Link to="/locacao-lavadora-piso" className="text-gray-400 hover:text-white transition-colors">Locação</Link></li>
                <li><Link to="/faq-locacao-lavadora-piso" className="text-blue-400 hover:text-blue-300 transition-colors">FAQ</Link></li>
                <li><Link to="/blog" className="text-gray-400 hover:text-white transition-colors">Blog</Link></li>
                <li><Link to="/reforma-tennant-m20" className="text-green-400 hover:text-green-300 transition-colors">Reforma Tennant M20</Link></li>
                <li><a href="/#contato" className="text-gray-400 hover:text-white transition-colors">Contato</a></li>
              </ul>
            </div>
            <div>
              <h5 className="text-lg font-bold mb-4">Contato</h5>
              <ul className="space-y-2 text-gray-400">
                <li>(31) 97182-3249</li>
                <li>Mário Campos, MG</li>
                <li>Seg-Sex: 08:00-18:00</li>
              </ul>
            </div>
          </div>
          <div className="border-t border-slate-800 pt-8 text-center text-gray-400">
            <p>&copy; 2025 WellTec - Locações e Serviços Técnicos. Todos os direitos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FAQLocacaoLavadoraPiso;
